import { FC } from 'react';
import styles from './cardLoader.module.scss';

const CardLoader: FC<{ width: string; height: string }> = ({ width, height }: { width: string; height: string }) => {
    return <div data-testid="card-loader" className={styles['card-loader']} style={{ width, height }} />;
};

export default CardLoader;
